
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/[[...campaignSlug]]",
      function () {
        return require("private-next-pages/c/[[...campaignSlug]].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/[[...campaignSlug]]"])
      });
    }
  